import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Icon } from '@unite-us/ui';
import { FormattedMessage } from 'react-intl';
import getLanguageNamesByCode from '../../utils/getLanguageNameByCode';
import getLanguagesNamesByIds from '../../utils/getLanguagesByIds';

function PdfScreeningForm({ data, signature, language, languages }) {
    const { screening, screening: { requestor } } = data;

    return (
        <div
            style={{
                width: '760px',
                backgroundColor: '#fff',
                color: '#000',
                padding: '40px',
                paddingLeft: '60px',
                lineHeight: 1.5,
                fontFamily: 'Proxima Nova, Helvetica Neue, Helvetica, Arial, sans-serif',
                fontSize: "16px",
            }}
        >
            <div className='flex justify-center mb-5'>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.2296 38.3346C25.6391 38.3346 25.8784 38.192 26.1749 37.9605C27.3474 37.0449 27.8309 35.7645 27.8309 34.1016V28.2185V25.9524V14.4005V9.01953C24.1564 13.2867 21.9309 18.836 21.9309 24.9088V28.2009V34.1014C21.9309 34.8322 21.7842 35.5245 21.5396 36.1694C22.2657 37.4602 23.6155 38.3346 25.2296 38.3346Z" fill="black" />
                    <path d="M30.3599 34.0992C30.3599 32.8858 30.3599 31.2086 30.3599 29.1821V14.4457V10.2179C30.3599 5.85114 32.7346 2.04042 36.2605 0V5.32199V20.4364V29.1821H36.2172C35.7167 35.2379 30.6453 39.9999 24.4595 39.9999C27.7183 39.9997 30.3599 37.3579 30.3599 34.0992Z" fill="black" />
                    <path d="M13.6457 39.0798C11.9978 38.0326 10.9006 36.1964 10.9006 34.0992C10.9006 32.8858 10.9006 31.2086 10.9006 29.1821V14.4457V10.2179C10.9006 5.85114 8.52594 2.04042 5 0V5.32199V20.4364V29.1821H5.0433C5.4737 34.3901 9.28759 38.6308 14.2802 39.7197C14.0563 39.5185 13.8444 39.3054 13.6457 39.0798Z" fill="black" />
                    <path d="M13.6455 39.0781C13.8442 39.3038 14.0561 39.5167 14.2801 39.7182C15.0934 39.8959 15.9344 39.9982 16.801 39.9982C15.6391 39.9982 14.5588 39.6576 13.6455 39.0781Z" fill="black" />
                    <path d="M19.3297 34.1014V28.2009V24.9088C19.3297 18.836 17.1031 13.2867 13.4292 9.01953V14.4005V25.9524V28.2185V34.1016C13.4292 37.3599 16.0718 40.0016 19.3297 40.0016C22.5887 40.0016 23.1696 40.0016 25.23 40.0016C21.9706 40.0014 19.3297 37.3596 19.3297 34.1014Z" fill="black" />
                    <path d="M18.4 9.94573L19.4695 6.65175L16.6665 4.61754H20.1316L21.2011 1.32422L22.2721 4.61754H25.7348L22.9331 6.65307L24.0034 9.94573L21.2011 7.91007L18.4 9.94573Z" fill="black" />
                </svg>
            </div>

            <div>
                <h1 className="text-4xl font-semibold text-black"><FormattedMessage id="uVGU0L" description="social-need-screening" defaultMessage="Social Needs Screening" /></h1>
                <p className="mt-4 flex items-center">
                    <span className="mr-2 flex items-center h-9 leading-36 pt-4">
                        <Icon icon="IconGlobe" color="#000" className="fill-current" />
                    </span>
                    <strong className="text-base text-black font-semibold"><FormattedMessage id="ZaOlqZ" description="language" defaultMessage="Language" />: {getLanguageNamesByCode(language)}</strong>
                </p>
            </div>

            <div className="h-px bg-black" style={{ marginTop: '30px', marginBottom: '70px', width: '900px', marginLeft: '-60px' }}></div>

            <h2 className="text-xl font-semibold text-black"><FormattedMessage
                id="HZaC7L"
                description="personalInformation"
                defaultMessage="Personal Information"
            /></h2>
            <div className="mt-8 space-y-4">
                <dl>
                    {[
                        {
                            label: <FormattedMessage
                                id="baGCLv"
                                description="firstName"
                                defaultMessage="First Name"
                            />,
value: requestor.first_name
                        },
                        {
                            label: <FormattedMessage
                                id="2cVC+q"
                                description="lastName"
                                defaultMessage="Last Name"
                            />,
value: requestor.last_name
                        },
                        {
                            label: <FormattedMessage
                                id="Hid0zr"
                                description="dateOfBirth"
                                defaultMessage="Date of Birth"
                            />,
value: moment.unix(requestor.date_of_birth).utc().format('MM-DD-YYYY')
                        },
                        {
                            label: <FormattedMessage
                                id="9cZViq"
                                description="phoneNumber"
                                defaultMessage="Phone number"
                            />,
value: requestor.phone_number
                        },
                        {
                            label: <FormattedMessage
                                id="u2ISfJ"
                                description="emailAddress"
                                defaultMessage="Email Address"
                            />,
value: requestor.email_address
                        },
                        {
                            label: <FormattedMessage
                                id="4ueNhi"
                                description="addressType"
                                defaultMessage="Address Type"
                            />,
value: requestor.address_type.charAt(0).toUpperCase() + requestor.address_type.slice(1)
                        },
                        {
                            label: <FormattedMessage
                                id="2U37j6"
                                description="address"
                                defaultMessage="Address"
                            />,
value: `${requestor.line_1}, ${requestor.city}, ${requestor.state}`
                        }
                    ].map((item) => (
                        <>
                            <dt className="text-base font-semibold mt-4 text-black">{item.label}</dt>
                            <dd className="text-base text-black leading-5 text-black">{item.value}</dd>
                        </>
                    ))}

                    {requestor.line_2 && (
                        <>
                            <dt className="text-base text-black font-semibold mt-4"><FormattedMessage
                                id="+/mcIK"
                                description="addressLine2"
                                defaultMessage="Address Line 2"
                            /></dt>
                            <dd className="text-base text-black leading-5">{requestor.line_2}</dd>
                        </>
                    )}

                    {requestor.preferred_written_languages && (
                        <>
                            <dt className="text-base text-black font-semibold mt-4"><FormattedMessage
                                id="q8T0PX"
                                description="preferredWrittenLanguages"
                                defaultMessage="Preferred Written Languages"
                            /></dt>
                            <dd className="text-base text-black leading-5">{getLanguagesNamesByIds(languages, requestor.preferred_written_languages)}</dd>
                        </>
                    )}

                    {requestor.preferred_spoken_languages && (
                        <>
                            <dt className="text-base text-black font-semibold mt-4"><FormattedMessage
                                id="RCuAgT"
                                description="preferredSpokenLanguages"
                                defaultMessage="Preferred Spoken Languages"
                            /></dt>
                            <dd className="text-base text-black leading-5">{getLanguagesNamesByIds(languages, requestor.preferred_spoken_languages)}</dd>
                        </>
                    )}
                </dl>
            </div>

            <div className="h-px bg-black w-full" style={{ marginTop: '70px', marginBottom: '70px' }}></div>

            <h3 className="text-lg font-semibold text-black">
                <FormattedMessage
                    id="ocN+75" description="screening-questions"
                    defaultMessage="Screening Questions"
                />
            </h3>
            <div className="mt-4 space-y-6">
                {screening.form_response.map((q, idx) => (
                    <div key={idx} className="break-inside-avoid">
                        <p className="text-base font-semibold text-black">{q.title}</p>
                        <p className="text-base text-black leading-5">{q.displayValue}</p>
                    </div>
                ))}
            </div>

            <div className="break-inside-avoid">
                <div className="h-px bg-black w-full" style={{ marginTop: '70px', marginBottom: '70px' }}></div>
                <h3 className="text-lg font-semibold text-black">
                    <FormattedMessage
                        id="2TSRZn" description="screeningConsent"
                        defaultMessage="Screening Consent"
                    />
                </h3>
                <p className="text-base text-black font-semibold mt-6">
                    <FormattedMessage
                        id="vb9iJW" description="screeningConsent2"
                        defaultMessage="We use this screening to understand needs our [members / patients / clients] have which could interfere with good health. We may share your answers with your other healthcare providers, and with your health plan and social services organizations, so they can determine if you qualify for any free non-medical services that could be helpful. Please check this box if you agree to continue. You can choose not to answer this survey, but we can only check for services if you do answer."
                    />
                    <br /><br />
                    <FormattedMessage
                        id="2DZwiH" description="screeningConsent3"
                        defaultMessage="You can choose to be screened later and may be eligible for extra services at that time. None of this will affect your ongoing Medicaid eligibility."
                    />
                </p>
                <p className="flex items-center mt-10">
                    <span className="mr-2 shrink-0 leading-36 pt-5">
                        <Icon icon="IconCheck" color="#000" className="w-5 h-5" />
                    </span>
                    <span className="text-base text-black leading-5">
                        <FormattedMessage
                            id="4EswtC" description="screeningConsent4"
                            defaultMessage="I consent to sharing screening information. *"
                        />
                    </span>
                </p>
            </div>

            <div className="page-break-before break-inside-avoid">
                <br />
                <div className="h-px bg-black w-full" style={{ marginTop: '70px', marginBottom: '70px' }}></div>
                <h3 className="text-lg font-semibold text-black">
                    <FormattedMessage
                        id="7FU+y1" description="networkConsent"
                        defaultMessage="Referral Network Consent"
                    />
                </h3>
                <p className="flex items-center mt-10">
                    <span className="mr-2 shrink-0 leading-36 pt-5">
                        <Icon icon="IconCheck" color="#000" className="w-5 h-5" />
                    </span>
                    <span className="text-base text-black leading-5">
                        <FormattedMessage
                            id="nupZUv"
                            description="networkConsentWithoutLink"
                            defaultMessage="I consent to sharing my information with a network of health and social service providers to connect me with services. For more information about how your information may be used, please "
                        />{' '}
                        <a href="https://uniteus.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="font-bold">
                            <FormattedMessage
                                id="70H6EA"                                
                                description="clickHereLink"
                                defaultMessage="click here"
                            />
                        </a>
                        .
                    </span>
                </p>

                <div className="mt-8">
                    <img src={signature} alt="Signature" className="h-36" />
                </div>
            </div>

        </div>
    );
};

export default PdfScreeningForm;
